function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  fill: "#E8ECFF",
  opacity: 0.408
}, /*#__PURE__*/React.createElement("path", {
  d: "M42.825 79.953c8.937 0 15.372.864 21.802-4.847 5.335-4.738 8.427-3.58 10.726-10.819C76.683 60.1 80 44.681 80 40c0-15.982-6.626-22.335-18.891-29.025C56.087 8.235 44.632 0 38.636 0c-6.83 0-15.934.125-21.443 3.616C10.758 7.694 4.097 16.22.837 23.563c-2.384 5.37 1.081 17.288 1.081 23.655 0 7.937 15.817 10.563 22.16 17.069 6.345 6.507 5.47 11.033 9.036 12.849 4.434 2.26.775 2.817 9.711 2.817z",
  transform: "translate(-643 -204) translate(301 53) translate(342 151)"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-643 -204) translate(301 53) translate(342 151) translate(3 3) translate(5 5)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 62,
  height: 35,
  x: 1,
  y: 28,
  fill: "#E8EDFC",
  stroke: "#428DFF",
  strokeWidth: 2,
  rx: 4
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A4C2F7",
  stroke: "#428DFF",
  strokeWidth: 2,
  d: "M1 47H63V52H1z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 38,
  height: 38,
  x: 13,
  y: 1,
  fill: "#E8EDFC",
  stroke: "#428DFF",
  strokeWidth: 2,
  rx: 4
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A4C2F7",
  stroke: "#428DFF",
  strokeWidth: 2,
  d: "M32 8.114l3.67 6.836 7.634 1.377-5.367 5.602 1.05 7.687-5.683-2.744c-.824-.398-1.784-.398-2.608 0h0l-5.682 2.744 1.05-7.687-5.368-5.602 7.635-1.377L32 8.114z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 26,
  height: 2,
  x: 24,
  y: 57,
  fill: "#428DFF",
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 15,
  height: 2,
  x: 6,
  y: 57,
  fill: "#428DFF",
  rx: 1
})))))));

function SvgIconCourse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCourse);
export default __webpack_public_path__ + "static/media/icon-course.4977b19f.svg";
export { ForwardRef as ReactComponent };